module.exports = __webpack_public_path__ + "img/circle_logo_transparent128.c8dd1e4a.png";